import React, { useState } from "react";

const SearchBar = ({ onSearch }) => {
  const [keyword, setKeyword] = useState("");
  const [location, setLocation] = useState("");
  const [filters, setFilters] = useState({
    datePosted: "",
    pay: "",
    jobType: "",
    education: "",
    industry: "",
    company: "",
    jobLanguage: "",
  });

  const [activeFilter, setActiveFilter] = useState(null);

  const handleSearch = () => {
    onSearch({ keyword, location, filters });
  };

  const handleFilterChange = (filterName, value) => {
    setFilters({ ...filters, [filterName]: value });
    setActiveFilter(null); // Close the dropdown after selecting
  };

  return (
    <div className="p-4 bg-gray-100">
      {/* Search Inputs */}
      <div className="flex flex-wrap justify-center items-center mb-4">
        <input
          type="text"
          placeholder="Job title, keywords, or company"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          className="border p-2 rounded mr-2 mb-2 w-full md:max-w-sm"
        />
        <input
          type="text"
          placeholder="City, state, or zip"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          className="border p-2 rounded mr-2 mb-2 w-full md:max-w-sm"
        />
        <button
          onClick={handleSearch}
          className="bg-indigo-900 text-white px-4 py-2 rounded w-full md:w-auto"
        >
          Search
        </button>
      </div>

      {/* Filter Buttons */}
      <div className="flex flex-wrap gap-2 justify-center">
        {[
          { label: "Date Posted", key: "datePosted", options: ["Any time", "Last 24 hours", "Last 7 days", "Last 14 days"] },
          { label: "Pay", key: "pay", options: ["Any", "0 - $50,000", "$50,000 - $100,000", "$100,000+"] },
          { label: "Job Type", key: "jobType", options: ["All types", "Full-time", "Part-time", "Contract", "Temporary", "Internship"] },
          { label: "Education", key: "education", options: ["All levels", "High School", "Associate Degree", "Bachelor's Degree", "Master's Degree", "Doctorate"] },
          { label: "Industry", key: "industry", options: ["All industries", "Technology", "Healthcare", "Finance", "Education", "Retail"] },
          { label: "Language", key: "jobLanguage", options: ["Any language", "English", "Spanish", "French", "German"] },
        ].map((filter) => (
          <div key={filter.key} className="relative w-full md:w-auto">
            <button
              onClick={() => setActiveFilter(activeFilter === filter.key ? null : filter.key)}
              className="bg-indigo-900 text-white px-3 py-1 rounded text-sm w-full md:w-auto"
            >
              {filter.label}
            </button>
            {activeFilter === filter.key && (
              <div className="absolute top-full mt-1 left-0 bg-white border rounded shadow-lg z-10 w-full md:w-48">
                {filter.options.map((option) => (
                  <div
                    key={option}
                    onClick={() => handleFilterChange(filter.key, option)}
                    className={`p-2 cursor-pointer hover:bg-indigo-100 ${
                      filters[filter.key] === option ? "bg-indigo-900 text-white" : ""
                    }`}
                  >
                    {option}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchBar;
